<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Laporan Tunggakan Hasil">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    TEMPOH TUNGGAKAN : {{ decodeURI(cari.title) }}
                    <!-- <div class="xs6 mr3">
                      <z-lookup 
                            label="Bulan"
                            url="bulanlookup"
                            :sort="false" :cache="false" v-model="cari.bulan" />
                        <z-lookup v-if="show_jabatan == true"
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user2'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input 
                            v-model="cari.tahun"
                            type="number"
                            label="Tahun"
                        />
                    </div> -->
                    
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="my1" bg-color="warning" dark  @click="back()" >Kembali</w-button>
                </div>
            </w-flex>
            <center v-if="!table.meta.current_page"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td rowspan="2">BIL</td>
                                <td rowspan="2">NO. HM</td>
                                <td colspan="3">CUKAI TANAH (RM)</td>
                                <td colspan="3">TUNGGAKAN CUKAI TANAH (RM)</td>
                                <td colspan="3">CUKAI PETAK (RM)</td>
                                <td colspan="3">TUNGGAKAN CUKAI PETAK (RM)</td>
                                <td colspan="3">CUKAI TALI AIR (RM)</td>
                                <td colspan="3">TUNGGAKAN CUKAI TALI AIR (RM)</td>
                                <td colspan="3">DENDA (RM)</td>
                                <td colspan="3">TUNGGAKAN DENDA (RM)</td>
                                <td colspan="3">NOTIS (RM)</td>
                                <td colspan="3">TUNGGAKAN NOTIS (RM)</td>
                                <td colspan="3">JUMLAH (RM)</td>
                            </tr>
                            <tr>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                                <td>PATUT KUTIP</td>
                                <td>TELAH KUTIP</td>
                                <td>BAKI</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items && table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                        <td>{{ dt.no }}</td>
                                        <td>{{ dt.no_hm }}</td>
                                        <td style="text-align: right">{{ dt.cukai_tanah_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.cukai_tanah_kutip }}</td>
                                        <td style="text-align: right">{{ dt.cukai_tanah_baki }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_tanah_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_tanah_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_tanah_baki }}</td>
                                        <td style="text-align: right">{{ dt.cukai_petak_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.cukai_petak_kutip }}</td>
                                        <td style="text-align: right">{{ dt.cukai_petak_baki }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_petak_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_petak_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_petak_baki }}</td>
                                        <td style="text-align: right">{{ dt.tali_air_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tali_air_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tali_air_baki }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_tali_air_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_tali_air_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_tali_air_baki }}</td>
                                        <td style="text-align: right">{{ dt.denda_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.denda_kutip }}</td>
                                        <td style="text-align: right">{{ dt.denda_baki }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_denda_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_denda_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_denda_baki }}</td>
                                        <td style="text-align: right">{{ dt.notis_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.notis_kutip }}</td>
                                        <td style="text-align: right">{{ dt.notis_baki }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_notis_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_notis_kutip }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_notis_baki }}</td>
                                        <td style="text-align: right">{{ dt.jumlah_patut_kutip }}</td>
                                        <td style="text-align: right">{{ dt.jumlah_kutip }}</td>
                                        <td style="text-align: right">{{ dt.jumlah_baki }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="29" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
                </div>
            </w-flex>
            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                    <w-button bg-color="success" class="mr3" @click="xls()" >
                        <w-icon>fal fa-file</w-icon>&nbsp;XLS
                    </w-button>
                </div>
            </w-flex>
            
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
    show_jabatan: [Array, Object, String],
  },
  data() {
    return {
        resourceurl: this.service_laporan+'kutipan/laporan/cukai_akaun_belum_terima_senarai',
        reload: true,
        loading: false,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Tunggakan Hasil', route: '/tunggakanhasil' },
            { label: 'Laporan Tunggakan Hasil', route: '/tunggakan/senarai_tunggakan' },
          ],
          cari : {type: '', bulan: '', tahun: '', jabatan_id: '', title: ''},
          }
  },
  methods: {

    search() {
        this.$inertia.visit(
                window.route("tunggakan.senarai_tunggakan") + 
                    "?tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga+
                    "&jabatan_id=" + this.cari.jabatan_id,
                { preserveScroll: true }
            );
        // this.getDataQuery();
    //   this.$inertia.visit(window.route('tunggakanhasil.tunggakanhasil')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },
    back() {
      window.history.back();
    },
    reset(){
      this.cari = {bulan: '', tahun: '', jabatan_id: ''}
      this.search()
    },

    cetak() {
        var cari_type = '';
        if(this.cari.type)
            cari_type = "&type=" + this.cari.type;
        var statik = '';
        if(this.cari.static)
            statik = '&static=true'
        window.open(this.service_laporan+'kutipan/laporan/cukai_akaun_belum_terima_senarai?cetak=1&user_id='+
        this.auth.user.id + statik + '&bulan='+this.cari.bulan+'&tahun='+this.cari.tahun + cari_type +"&jabatan_id=" + this.cari.jabatan_id+"&par=" + this.cari.par,'_blank');
    },
    xls() {
        var cari_type = '';
        if(this.cari.type)
            cari_type = "&type=" + this.cari.type;
        var statik = '';
        if(this.cari.static)
            statik = '&static=true'
        window.open(this.service_laporan+'kutipan/laporan/cukai_akaun_belum_terima_senarai?cetak=1&user_id='+
        this.auth.user.id + statik + '&bulan='+this.cari.bulan+'&tahun='+this.cari.tahun + cari_type +"&jabatan_id=" + this.cari.jabatan_id+"&par=" + this.cari.par+"&xls=1",'_blank');
    },
    async getDataQuery() {
        this.loading = true;
        var cari_type = '';
        if(this.cari.type)
            cari_type = "&type=" + this.cari.type;
        const resp = await axios.get(
            this.service_laporan + "kutipan/laporan/cukai_akaun_belum_terima_senarai?user_id=" + this.auth.user.id +
                "&bulan=" + this.cari.bulan +
                "&tahun=" + this.cari.tahun + cari_type +
                "&jabatan_id=" + this.cari.jabatan_id
                
        );
        this.table = resp.data;
        this.loading = false;
    },
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.bulan == 'undefined'){this.cari.bulan = ''}
    if(this.cari.tahun == 'undefined'){this.cari.tahun = ''}
    if(this.cari.jabatan_id == 'undefined'){this.cari.jabatan_id = ''}
    // if(this.cari.type){
    //     this.getDataQuery()
    // }
    console.log(this.cari);
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>